import {ApiClient} from '@hconnect/apiclient'
import {useCallback} from 'react'

import {MY_READ_IN_APP_NOTIFICATIONS_SEGMENT, NOTIFICATIONS_SEGMENT} from '../consts'

export const useMarkNotificationsAsRead = (onSuccess?: (id: string) => void) => {
  return useCallback(
    async (id: string) => {
      try {
        await ApiClient.axiosInstance.post<string[]>(
          `/${NOTIFICATIONS_SEGMENT}/${MY_READ_IN_APP_NOTIFICATIONS_SEGMENT}`,
          [id]
        )
        onSuccess?.(id)
      } catch (error) {
        console.error(error)
      }
    },
    [onSuccess]
  )
}
